import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import { Admin, Resource } from 'react-admin';
import { createRoot } from 'react-dom/client';
import { LoginPage } from './auth/LoginPage';
import { CustomLayout } from './layout/CustomLayout';
import { authProvider } from './providers/authProvider';
import { dataProvider } from './providers/dataProvider';
import { AdCreate, AdEdit, AdList, AdShow } from './resources/ads';
import { AdvertiserAccountList, AdvertiserAccountShow } from './resources/advertiserAccounts';
import { CampaignCreate, CampaignEdit, CampaignList, CampaignShow } from './resources/campaigns';
import { CommentReportList, CommentReportShow } from './resources/commentReports';
import { ImageRunList } from './resources/imageRuns';
import { QuestionReportList, QuestionReportShow } from './resources/questionReports';
import { theme } from './theme';

const App = () => {
  // Keep data provider stable to avoid re-renders
  const provider = useMemo(() => dataProvider, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Admin
        title="Q4uDoc Admin"
        dataProvider={provider}
        authProvider={authProvider}
        loginPage={LoginPage}
        layout={CustomLayout}
        disableTelemetry
      >
        <Resource
          name="advertiser-accounts"
          list={AdvertiserAccountList}
          show={AdvertiserAccountShow}
          recordRepresentation="name"
          options={{ label: 'Advertisers' }}
        />
        <Resource
          name="campaigns"
          list={CampaignList}
          edit={CampaignEdit}
          create={CampaignCreate}
          show={CampaignShow}
          recordRepresentation="name"
        />
        <Resource
          name="ads"
          list={AdList}
          edit={AdEdit}
          create={AdCreate}
          show={AdShow}
          recordRepresentation="title"
        />

        <Resource
          name="questionReports"
          list={QuestionReportList}
          show={QuestionReportShow}
          options={{ label: 'Question Reports' }}
        />
        <Resource
          name="comment-reports"
          list={CommentReportList}
          show={CommentReportShow}
          options={{ label: 'Reported Comments' }}
        />
        <Resource name="image-runs" list={ImageRunList} options={{ label: 'Image Runs' }} />
      </Admin>
    </ThemeProvider>
  );
};

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(<App />);
